import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Pipe({
  name: 'subProjectStatus'
})
export class SubProjectStatusPipe implements PipeTransform {
  constructor(private service: ConfigurationService) {}

  transform(statusId: number): string {
    const item = this.service.subProjectStatus.find(
      (status) => status.id === statusId
    );
    return item ? item.name : '';
  }
}
